import { render } from "./ServerInfoView.vue?vue&type=template&id=9bc3ccc2&scoped=true"
import script from "./ServerInfoView.vue?vue&type=script&lang=js"
export * from "./ServerInfoView.vue?vue&type=script&lang=js"

import "./ServerInfoView.vue?vue&type=style&index=0&id=9bc3ccc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc3ccc2"]])

export default __exports__